/**
 * EmbedGallery page — Standalone page for iframe embedding.
 * Influencers can embed this on their website/blog:
 * <iframe src="https://gamepoint.com/embed/best-drawing-challenge-abc123" />
 */

import EmbeddableGallery from "@/components/EmbeddableGallery";
import { useParams } from "wouter";

export default function EmbedGallery() {
  const params = useParams<{ slug: string }>();

  if (!params.slug) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
        <p className="text-sm text-muted-foreground">Invalid embed URL</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground p-4">
      <EmbeddableGallery
        gameSlug={params.slug}
        limit={12}
        showHeader={true}
      />
    </div>
  );
}
